module.exports = __webpack_public_path__ + "static/img/QXZ.4233218a.jpg";